import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ApiService } from '../../../../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { FileUploadComponent } from '../../../../../common/file-upload/file-upload.component';
import { Evento, MezzoTrasporto } from '../../../../../shared/interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

@Component({
  selector: 'app-add-mezzo-trasporto-accrediti-backoffice',
  templateUrl: './add-mezzo-trasporto-accrediti-backoffice.component.html',
  styleUrl: './add-mezzo-trasporto-accrediti-backoffice.component.css'
})
export class AddMezzoTrasportoAccreditiBackofficeComponent implements OnInit {

  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute
  ) {}
  
  @Input() visible: boolean = false;  
  @Input() evento?: Evento;

  @Output() close = new EventEmitter<boolean>();

  tipologie: { tipologia: string }[] = [
    { tipologia: 'Furgone Piccolo' },
    { tipologia: 'Furgone Medio' },
    { tipologia: 'Motrice' },
    { tipologia: 'Bilico' },
  ];
  tipologie_filtrate: { tipologia: string }[] = [];

  loading: boolean = false;
  
  formMezzo!: FormGroup;

  ngOnInit(): void {

    this.formMezzo = new FormGroup({
      tipo: new FormControl(null, Validators.required),
      targa: new FormControl(null, Validators.required),
      azienda: new FormControl(null, Validators.required),      
    });
  }

  onFilterTipologie(event: AutoCompleteCompleteEvent) {
    this.tipologie_filtrate = [...this.tipologie].filter((tipo) => tipo.tipologia.toLowerCase().indexOf(event.query.toLowerCase()) == 0).length <= 0 ? [{ tipologia: event.query }] : [...this.tipologie].filter((tipo) => tipo.tipologia.toLowerCase().indexOf(event.query.toLowerCase()) == 0);
  }

  onClose() {
    this.visible = false;
    this.close.emit(this.visible);
  }

  onAdd() {

    let mezzo = {
      id_evento: (this.evento?.id || 0).toString(),
      tipologia: this.formMezzo.get('tipo')?.value ? this.formMezzo.get('tipo')?.value.tipologia : '',
      targa: this.formMezzo.get('targa')?.value || '',
      ditta: this.formMezzo.get('azienda')?.value || '',
    }  

    this.apiService.addMezzoTrasporto(mezzo).subscribe({
      next: (data) => this.apiService.setMezziTrasportoEvento(this.evento?.id!),
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.formMezzo.reset();
        this.formMezzo.markAsUntouched();
        this.formMezzo.markAsPristine();    

        this.onClose()
      }
    });

  }

}
